import { Component, Input } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BaseFormControl } from '../base/base-form-control.directive';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-select',
    standalone: true,
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        CommonModule
    ]
})
export class SelectComponent extends BaseFormControl<any> {
  @Input() multiple = false;
}